module.exports = __webpack_public_path__ + "static/media/denwa.020f783a.png";